import React from 'react'

import { externalRoutes } from '../../constants/routes'
import Logo from '../../static/Img/logo.png'
import * as S from './styled'

const Footer: React.FC = () => {
  return (
    <S.Footer>
      <a
        href={externalRoutes.projectWebsite}
        target='_blank'
        rel='noopener noreferrer'
      >
        <S.Img src={Logo} />
      </a>
    </S.Footer>
  )
}

export default Footer
